<template>
    <v-container >
        <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.name') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.name }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.description') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.type') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ getNodeDesc(item) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.extension') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.extensionNumber }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.xsiNodeId') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.xsiNodeId }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.office') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ getOfficeName(item) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.phoneNumber') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.phoneNumber }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.terminal') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.terminalType }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
            <v-col class="ma-0 pa-0" cols="3">
                <v-list-item class="ma-0 pa-0" two-line>
                    <v-list-item-content>
                        <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Nodes.emailWebex') }}</p></v-list-item-title>
                        <v-list-item-subtitle class="mt-n3">{{ item.emailWebex }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import Utils from "@/mixins/Utils";

export default {
    name: "NodesExpansion",
  mixins: [Utils],
  props: {
        item: {
            type: Object
        },
        headers: {
            type: Array
        }
    },
  computed: {
    ...mapGetters(['getDefsNodeTypes', 'getOfficesByCompanyInfo', 'getEditOfficesByCompanyInfoId', 'getEditCompanyInfo']),
  },
  methods: {
    getNodeDesc(item) {
      return this.getDefsNodeTypes?.find((e) => e.nodeTypeId === item.nodeTypeId)?.nodeTypeDesc
    },
    getOfficeName(item) {
      return this.loadCompanyOffices()?.find((e) => e.officeId === item.officeId)?.callcenterOfficeName

    },
  },


}
</script>
